import { Company } from "./company";

export class CompanyDetail {
    id?: string;
    company?: Company;
    isCreationMode?: boolean;
    isEditMode?: boolean;
    isReadOnlyMode?: boolean;
    selectedContractID?: string;
    constructor(companyDetail?: CompanyDetail) {
        this.id = companyDetail?.id;
        this.company = companyDetail?.company;
        this.isCreationMode = companyDetail?.isCreationMode || false;
        this.isEditMode = companyDetail?.isEditMode || false;
        this.isReadOnlyMode = companyDetail?.isReadOnlyMode || false;
        this.selectedContractID = companyDetail?.selectedContractID;
    }

}
